import type { SyncStatus } from "../lib/types";

interface Props {
  status: SyncStatus;
  onSync: () => void;
}

export function SyncStatus({ status, onSync }: Props) {
  const label = formatStatus(status);
  const isLoading = status.kind === "syncing";

  return (
    <button
      onClick={onSync}
      className="flex items-center gap-1.5 text-xs text-gray-500 hover:text-gray-800 transition-colors"
      title="Tap to sync"
    >
      {isLoading ? (
        <span className="flex gap-0.5 items-center">
          <Dot delay="0ms" />
          <Dot delay="150ms" />
          <Dot delay="300ms" />
        </span>
      ) : (
        <span
          className={`w-2 h-2 rounded-full ${
            status.kind === "synced"
              ? "bg-green-500"
              : status.kind === "offline"
                ? "bg-gray-400"
                : status.kind === "error"
                  ? "bg-red-500"
                  : "bg-gray-300"
          }`}
        />
      )}
      <span>{label}</span>
    </button>
  );
}

function Dot({ delay }: { delay: string }) {
  return (
    <span
      className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce"
      style={{ animationDelay: delay }}
    />
  );
}

function formatStatus(status: SyncStatus): string {
  switch (status.kind) {
    case "idle":
      return "sync";
    case "syncing":
      return "syncing";
    case "synced": {
      const mins = Math.round((Date.now() - status.at) / 60000);
      if (mins < 1) return "synced now";
      if (mins === 1) return "synced 1m ago";
      return `synced ${mins}m ago`;
    }
    case "offline":
      return "offline";
    case "error":
      return "sync error";
  }
}
